import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import { TOption } from '@treezor/design-system';

import { ISearch, ISearchField } from '@/ui-kit/table-filters/filters.type';

import { IAllWalletsFiltersFormFields } from '@/features/wallets/store/types/agent-wallets.types';
import { ISearchWallet } from '@/features/wallets/store/models/wallet.model';
import { extractWalletIdFromIBAN } from '@/utils/tools/IBAN/IBANTools';

export function mapAllWalletsSearch(value: { key: 'walletId' | 'iban'; value: string }): ISearchWallet {
  const searchValue = value.value;
  if (searchValue === '' || searchValue === undefined || searchValue === null) return {};
  if (value.key === 'walletId') {
    return { walletId: Number(searchValue) };
  }
  if (value.key === 'iban') {
    const extractedWalletId = extractWalletIdFromIBAN(value.value)?.walletId;
    if (extractedWalletId) {
      return { walletId: extractedWalletId };
    } else {
      return { walletId: Number(searchValue) };
    }
  }
}

export function useAllWalletsSearchField(methods: UseFormReturn<IAllWalletsFiltersFormFields>, onChange): ISearchField {
  const { t } = useTranslation();

  const handleSearchChange = useCallback(
    (value: ISearch) => {
      const currentValue = methods.getValues('search');
      const newValue = Object.keys(value).reduce<ISearch>((prev, current) => {
        return { ...prev, [current]: value[current] === null ? currentValue[current] : value[current] };
      }, {} as ISearch);
      methods.setValue('search', newValue);
      if (value.key !== null && value.value !== null) {
        onChange();
      }
    },
    [onChange, methods],
  );

  const searchOptions: TOption[] = [
    { label: t('pages.currentProfiles.wallets.wallet.walletId'), value: 'walletId' },
    { label: t('pages.currentProfiles.wallets.wallet.iban'), value: 'iban' },
  ];
  const searchValue = methods.watch('search');

  return { value: searchValue, handleChange: handleSearchChange, options: searchOptions };
}
